<template>
  <svg
    class="Basketball"
    width="32"
    height="32"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 1C30.4934 1 39 9.50659 39 20C39 30.4934 30.4934 39 20 39C9.50659 39 1 30.4934 1 20C1 9.50659 9.50659 1 20 1Z"
      fill="var(--iconColor, var(--colorOrange))"
      stroke="var(--strokeColor, var(--colorOffBlack))"
      stroke-width="2"
    />
    <path
      d="M20 1C20.3354 1 20.6688 1.00919 21 1.02637V19H24.0322C24.3868 13.25 27.7774 8.32114 32.6211 5.79883C33.1487 6.26804 33.6506 6.76542 34.123 7.29004C29.6137 9.37884 26.4034 13.7967 26.0361 19H38.9746C38.9918 19.3312 39 19.6646 39 20C39 20.3354 38.9918 20.6688 38.9746 21H26.0361C26.4034 26.2031 29.6139 30.6201 34.123 32.709C33.6506 33.2336 33.1487 33.7309 32.6211 34.2002C27.7776 31.6778 24.3868 26.7498 24.0322 21H21V38.9736C20.6688 38.9908 20.3354 39 20 39C19.6646 39 19.3312 38.9908 19 38.9736V21H15.9678C15.6132 26.7498 12.2224 31.6778 7.37891 34.2002C6.85133 33.7309 6.34939 33.2336 5.87695 32.709C10.3861 30.6201 13.5966 26.2031 13.9639 21H1.02539C1.00822 20.6688 1 20.3354 1 20C1 19.6646 1.00822 19.3312 1.02539 19H13.9639C13.5966 13.7967 10.3863 9.37884 5.87695 7.29004C6.34939 6.76542 6.85133 6.26804 7.37891 5.79883C12.2226 8.32114 15.6132 13.25 15.9678 19H19V1.02637C19.3312 1.00919 19.6646 1 20 1Z"
      fill="var(--strokeColor, var(--colorOffBlack))"
    />
  </svg>
</template>

<style lang="scss" scoped>
.Basketball {
  :deep(path) {
    transition: 350ms;
    transition-property: stroke, fill;
  }
}
</style>
